import { ChangeDetectionStrategy, Component, inject, Input, Signal } from '@angular/core';
import { GameId } from 'src/app/model/game/game-id';
import { ThemeService } from 'src/app/core/services/theme/theme.service';
import { ModalController } from '@ionic/angular/standalone';
import { safeModalDismiss } from 'src/app/shared/utils/modal.utils';
import { EventName } from 'src/app/core/services/analytics/event-names';
import { AnalyticsService } from 'src/app/core/services/analytics/analytics.service';
import { DuelTierDataWithMeta } from 'src/app/core/services/tiers/tiers.service';
import { WaitingOpponentsData } from 'src/app/core/api/player/schemas/waiting-opponents';
import { TournamentDataModel } from 'src/app/core/services/tournament/model/tournament-data-model';
import { ThemePipe } from '../../../core/pipes/theme.pipe';
import { NavButtonComponent } from '../../buttons/nav-button/nav-button.component';
import { WagerTierListComponent } from '../../panels/wager-tier-list/wager-tier-list/wager-tier-list.component';
import { NgStyle, NgClass } from '@angular/common';
import {
  DuelPaymentEventData,
  TournamentPaymentEventData,
} from 'src/app/shared/types/payment-events';

@Component({
  selector: 'app-wager-drawer',
  templateUrl: './wager-drawer.component.html',
  styleUrls: ['./wager-drawer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgStyle, NgClass, NavButtonComponent, WagerTierListComponent, ThemePipe],
})
export class WagerDrawerComponent {
  @Input({ required: true }) gameId!: GameId;
  @Input({ required: true }) allTiers!: Signal<DuelTierDataWithMeta[]>;
  @Input({ required: true }) currentTournamentData!: Signal<TournamentDataModel | undefined>;
  @Input({ required: true }) waitingOpponentsStandard!: Signal<WaitingOpponentsData | undefined>;

  private modalController = inject(ModalController);
  private analyticsService = inject(AnalyticsService);

  themeService = inject(ThemeService);
  drawerConfig = this.themeService.payDrawerConfig();

  get drawerStyles(): [string, string][] {
    const key = 'drawer';
    return [
      ['background', key],
      ['border-radius', key],
    ];
  }

  get glowClass(): string {
    return this.themeService.payDrawerConfig().gradient === 'circle'
      ? 'glow-circle'
      : 'glow-linear';
  }

  async onPracticeClick(): Promise<void> {
    await safeModalDismiss(this.modalController, null, 'practiceClick');
    this.analyticsService.log(EventName.SelectTier, { tierId: 'practice' });
  }

  async onLocalClick(): Promise<void> {
    await safeModalDismiss(this.modalController, null, 'localClick');
  }

  async onWagerClick(data: DuelPaymentEventData): Promise<void> {
    await safeModalDismiss(this.modalController, data, 'wagerClick');
    this.analyticsService.log(EventName.SelectTier, { tierId: data.tierData.tierId });
  }

  async onTournamentPlayClick(data: TournamentPaymentEventData): Promise<void> {
    await safeModalDismiss(this.modalController, data, 'tournamentPlayClick');
    this.analyticsService.log(EventName.TournamentSelectTier, {
      tierId: data.tournamentData.tierId,
      tournamentId: data.tournamentData.tournamentId,
    });
  }

  async onCloseClick(): Promise<void> {
    await safeModalDismiss(this.modalController);
  }
}
